var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-image-automatica'),_c('article-ticket-option-drop-down'),_c('articles-pdf-option-drop-down'),_c('articles-bar-code-pdf'),_c('article-pdf'),_c('seleccion-especial'),_c('excel-export'),_c('reset-stock-option-drop-down')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }